<template>
  <div class="stats-header">
    <div class="stats-header-top" v-for="(headerStat, index) in opponentHeaderStats" :key="index">
      <BaseText5 :text="headerStat.label"/>
      <BaseText3 :text="headerStat.value"/>
    </div>
    <div class="stats-header-bottom">
      <DonutChart label="striking accuracy" :value="opponentStrikingAccuracy" :ratio="parseFloat(opponentStrikingAccuracy / 100)"/>
      <DonutChart label="grappling accuracy" :value="opponentGrapplingAccuracy" :ratio="parseFloat(opponentGrapplingAccuracy / 100)"/>
    </div>
  </div>
</template>

<script>
import BaseText3 from '@/components/BaseText3/BaseText3'
import BaseText5 from '@/components/BaseText5/BaseText5'
import DonutChart from '../../../../components/DonutChart/DonutChart'
export default {
  props: {
    opponentHeaderStats: {
      type: Array,
      required: true
    },
    opponentStrikingAccuracy: {
      type: String,
      required: true
    },
    opponentGrapplingAccuracy: {
      type: String,
      required: true
    }
  },
  components: {
    DonutChart,
    BaseText5,
    BaseText3
  }
}
</script>

<style lang="scss" scoped>
.stats-header {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  margin: 2rem 0 0 0;
}
.stats-header-top {
  width: calc(100% / 3);
  padding: 0 1rem 0 1rem;
}
.stats-header-bottom {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  .donut-chart {
    width: calc(100% / 3);
    padding: 1.5rem 1.5rem 0 1.5rem;
  }
}
</style>
